/*
# -----------------------------------------------------------------------------
# Component: debitNoteFilterMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 10/May/2019
# Comments: Responsible for all search filter functionality for Manage DebitNote
# -----------------------------------------------------------------------------
*/
export const debitNoteFilterMixin = {
  data() {
    return {
      branches: [],
      debitNoteForm: {
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionType: null,
        fund: null,
        transactionDateFrom: null,
        transactionDateTo: null,
        currency: null,
        actionName: null,
        applyFilters: ''
      },
      debitNoteFormLabel: {
        branch: 'Branch',
        accountNo: 'Account No.',
        documentNo: 'Document No.',
        transactionType: 'Transaction Type',
        fund: 'Fund',
        transactionDateFrom: 'Transaction Date From',
        transactionDateTo: 'Transaction Date To',
        currency: 'Currency'
      },
      showBranchHelpList: false,
      filtersBranchLabel: {
        branch: 'Branch'
      },
      filtersBranch: {
        branch: undefined
      },
      branchItems: [],
      totalItemsBranch: 0,
      branchHeaders: [
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationBranch: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showAcctNoHelpList: false,
      showDocNoHelpList: false,
      filtersDocNoLabel: {
        documentNo: 'Document No.'
      },
      filtersDocNo: {
        documentNo: undefined
      },
      docNoItems: [],
      totalItemsDocNo: 0,
      docNoHeaders: [
        { text: 'Document No.', align: 'left', value: 'documentNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationDocNo: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showCurrencyHelpList: false
    }
  },
  methods: {
    doClearFilters() {
      var thisPage = this
      this.defaultFilter = {}
      // Iterate through each object field, key is name of the object field
      Object.keys(this.debitNoteForm).forEach(function(key, index) {
        thisPage.debitNoteForm[key] = ''
      })
      this.performSearch()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('debitNoteForm').then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.debitNoteForm.applyFilters = 'Yes'
          this.performSearch()
        }
      })
    }
  },
  watch: {
    'paginationBranch': function (value) {
      this.fetchBranchData()
    },
    'paginationDocNo': function (value) {
      this.fetchDbDocNoData()
    }
  }
}
